import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center flex-wrap mb-5 gap-3" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center position-relative",
  style: {"width":"200px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "全部类型", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = {
  key: 0,
  class: "min-w-100px"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-80px" }, "类型", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "变动金额", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "变动前", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "变动后", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "备注", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, "时间", -1)
const _hoisted_15 = { class: "text-gray-600 fw-semibold" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "text-muted fs-7" }
const _hoisted_18 = { class: "badge badge-light-primary" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["colspan"]
const _hoisted_21 = { class: "d-flex justify-content-end py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showUserColumn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-solid form-control-sm",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.user_mobile) = $event)),
              placeholder: "手机号"
            }, null, 512), [
              [_vModelText, _ctx.filters.user_mobile]
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.dateRange,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateRange) = $event)),
        type: "daterange",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        "value-format": "YYYY-MM-DD",
        size: "small",
        style: {"width":"240px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.log_type) = $event)),
        class: "form-select form-select-solid form-select-sm",
        style: {"width":"140px"}
      }, [
        _hoisted_3,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logTypes, (t) => {
          return (_openBlock(), _createElementBlock("option", {
            key: t.value,
            value: t.value
          }, _toDisplayString(t.label), 9, _hoisted_4))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.filters.log_type]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control form-control-solid form-control-sm",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.min_amount) = $event)),
        placeholder: "最小金额",
        style: {"width":"120px"}
      }, null, 512), [
        [_vModelText, _ctx.filters.min_amount]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control form-control-solid form-control-sm",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.max_amount) = $event)),
        placeholder: "最大金额",
        style: {"width":"120px"}
      }, null, 512), [
        [_vModelText, _ctx.filters.max_amount]
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary btn-sm",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
      }, "搜索")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_7, [
            (_ctx.showUserColumn)
              ? (_openBlock(), _createElementBlock("th", _hoisted_8, "用户"))
              : _createCommentVNode("", true),
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13,
            _hoisted_14
          ])
        ]),
        _createElementVNode("tbody", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id
            }, [
              (_ctx.showUserColumn)
                ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                    _createElementVNode("div", null, _toDisplayString(item.user_nickname), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(item.user_mobile), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(item.log_type_text), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(item.amount >= 0 ? 'text-success' : 'text-danger')
                }, _toDisplayString(item.amount >= 0 ? '+' : '') + _toDisplayString(item.amount), 3)
              ]),
              _createElementVNode("td", null, _toDisplayString(item.before_amount), 1),
              _createElementVNode("td", null, _toDisplayString(item.after_amount), 1),
              _createElementVNode("td", null, _toDisplayString(item.note), 1),
              _createElementVNode("td", null, _toDisplayString(item.created_at), 1)
            ]))
          }), 128)),
          (_ctx.items.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                _createElementVNode("td", {
                  colspan: _ctx.showUserColumn ? 7 : 6,
                  class: "text-center text-muted py-10"
                }, "暂无数据", 8, _hoisted_20)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_vxe_pager, {
        "current-page": _ctx.page.currentPage,
        "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.page.currentPage) = $event)),
        "page-size": _ctx.page.pageSize,
        "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page.pageSize) = $event)),
        total: _ctx.page.totalResult,
        layouts: ['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total'],
        onPageChange: _ctx.onPageChange
      }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
    ])
  ]))
}